module.exports = __webpack_public_path__ + "5db9642110e6c2493935498fcd838de1.svg";